/**
 * SpeciesInput component
 * Finds inputs with js-species-input class and fills them with values from a meta tag
 */
export const SpeciesInput = {
	selectors: {
		inputs: '.js-species-input',
		validationKeyMeta: 'meta[name="tk:species-validation-key"]',
	},

	init() {
		[...document.querySelectorAll(this.selectors.inputs)].forEach((input) => {
			const metaTag = document.querySelector(this.selectors.validationKeyMeta);
			const validationKey = metaTag ? metaTag.getAttribute('content') : null;

			if (!validationKey) {
				console.warn('No validation key found.');
				return;
			}

			input.value = validationKey;

			// Dispatch input event to trigger any listeners
			const event = new Event('input', { bubbles: true });
			input.dispatchEvent(event);
		});
	},
};

SpeciesInput.init();
